module.exports = __webpack_public_path__ + "img/springroll_done_2.4f83b17f.jpg";